import 'vuetify/styles'
import AppConfig from '@/shared/services/app_config';
import App from '@/app.vue';
import { createApp } from 'vue';
import markedDirective from '@/marked_directive';
import submitOnModEnterDirective from '@/submit_on_mod_enter_directive';
import { pick } from 'lodash-es';
import * as Sentry from '@sentry/vue';
import PlausibleService from '@/shared/services/plausible_service';
import { installVitePreloadErrorHandler } from '@/shared/services/chunk_error_handling';
import PushSubscriptionService from '@/shared/services/push_subscription_service';
import EventBus from '@/shared/services/event_bus';

installVitePreloadErrorHandler();

try {
  document.querySelectorAll("link[rel=stylesheet][href*=themeauto]")[0].remove();
} catch {
  // noop
}

import { I18n } from './i18n'
import vuetify from './plugins/vuetify'
import router from './routes'

import boot from '@/shared/helpers/boot';
import { beforeSend } from '@/shared/helpers/sentry_event.mjs';
import Session from '@/shared/services/session';
import AccountCompletionService from '@/shared/services/account_completion_service';
import { plugin as Slicksort } from 'vue-slicksort';

boot(function(data) {
  Session.apply(data);

  const app = createApp(App);
  if (AppConfig.sentry_dsn) {
    Sentry.init({
      app,
      dsn: AppConfig.sentry_dsn,
      beforeSend,
      ignoreErrors: [
        "Avoided redundant navigation to current location",
        "NotFoundError: Node.removeChild",
        "NotFoundError: Failed to execute 'removeChild' on 'Node'",
        "NotFoundError: The object can not be found here",
        "NotFoundError: Node was not found",
        "null is not an object (evaluating 'r.addEventListener')",
        "Cannot read property 'addEventListener' of null",
        "evaluating 't.addEventListener'",
        "ResizeObserver loop limit exceeded",
        "MetaMask detected another web3",
        "Failed to connect to MetaMask",
        "AbortError: The operation was aborted",
        "ResizeObserver loop completed with undelivered notifications",
        "TypeError: cancelled",
        "UnhandledRejection: Non-Error promise rejection captured with value",
        "ChunkLoadError: Loading chunk chunk-",
        "TypeError: annulé",
        "Permission denied to access property \"dispatchEvent\" on cross-origin object",
        "TypeError: Failed to fetch",
        "TypeError: Load failed",
        "Non-Error promise rejection captured with keys: exception, ok, status, statusText",
        /__firefox__/
      ],
      integrations: [Sentry.browserTracingIntegration({ router })],
      tracesSampleRate: AppConfig.features.app.sentry_sample_rate,
      tracePropagationTargets: ["localhost", AppConfig.baseUrl, /^\//],
    });

    Sentry.setTag("loomio_version", AppConfig.version);
    Sentry.setUser(pick(Session.user(), ['id', 'name', 'email', 'username']));
  }

  PlausibleService.boot();
  PlausibleService.trackPageview();

  app.use(I18n).use(vuetify).use(router).use(Slicksort)
  app.directive('marked', markedDirective)
  app.directive('submit-on-mod-enter', submitOnModEnterDirective)
  app.mount("#app")

  // SSO returns and page reloads do not pass through AuthService, so check
  // account completion only after the modal launcher has mounted.
  AccountCompletionService.maybeOpen();

  const reconcilePushSubscription = () => PushSubscriptionService.reconcile().catch(() => {});
  EventBus.$on('signedIn', reconcilePushSubscription);
  if (Session.isSignedIn()) reconcilePushSubscription();
});
